import { render, staticRenderFns } from "./UkrTreasuresPayPalButtonsTableMobile.vue?vue&type=template&id=401cd0de&scoped=true"
import script from "./UkrTreasuresPayPalButtonsTableMobile.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresPayPalButtonsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cd0de",
  null
  
)

export default component.exports